import axios from 'axios'
import { mapGetters } from 'vuex'
import { saveAs } from 'file-saver/FileSaver'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import FieldHorizontal from '@/components/FieldHorizontal/FieldHorizontal'
import Map from '@/components/Map/Map'

export default {
  name: 'SessionRow',
  props: ['session'],
  data() {
    return {
      open: false,
      isLoading: false,
      mapKey: 0
    }
  },
  components: {
    FontAwesomeIcon,
    FieldHorizontal,
    Map
  },
  computed: {
    ...mapGetters({
      pendingSessions: 'pendingSessions',
      sessionStatisticsLoading: 'sessionStatisticsLoading',
      currentUser: 'currentUser'
    }),
    today() {
      if (this.sessionLoading) return false
      const now = new Date()
      const sessionTime = new Date(this.session.datetimeEnd)
      return now - sessionTime < 14400 // less than 4 hours
    }
  },
  methods: {
    openRow(bool, id) {
      this.$data.open = bool
      if (bool) this.$store.dispatch('getTinySessionData', { session: id })
        .then(() => this.mapKey += 1)
        .catch(() => this.mapKey += 1)
    },
    selectSession(id, event) {
      this.$store.dispatch('selectSession', { id, checked: event.target.checked })
    },
    exportOriginalCSV(sessionId) {
      this.isLoading = true
      const exportURL = `${this.$store.state.api.host}/original_csv/${sessionId}`
      axios(exportURL)
        .then(response => {
          const blob = new Blob([response.data], { type: response.data.type })
          const filename = `SEMS-export-original-csv-${sessionId}.csv`
          saveAs(blob, filename)
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SessionRow/script.js